/**
 * One document.
 *
 * The open button asks the API where to send the browser and goes there. It
 * builds no URL, holds no storage key and never learns how the bytes will
 * arrive. A locked document opens the undertaking instead, so a Tier 2 file is
 * not requestable from this screen until an acceptance is on file.
 */

import type { PortalDocument } from '@insuredhq/contract';

import { LOCKED_LABEL, OPENING_LABEL, OPEN_LABEL, WATERMARK_NOTICE } from '../copy';
import { formatDate } from '../dates';

interface DocumentRowProps {
  document: PortalDocument;
  opening: boolean;
  onOpen: (document: PortalDocument) => void;
}

export function DocumentRow({ document, opening, onOpen }: DocumentRowProps) {
  return (
    <li className={document.locked ? 'document document-locked' : 'document'}>
      <div className="document-detail">
        <h3>{document.title}</h3>
        {document.description === null ? null : (
          <p className="document-desc">{document.description}</p>
        )}
        <p className="document-meta">
          Version {document.version}. Updated {formatDate(document.updatedAt)}.
        </p>
        {document.watermark ? <p className="document-meta">{WATERMARK_NOTICE}</p> : null}
      </div>
      <button
        type="button"
        className="button-secondary button-compact"
        disabled={opening}
        onClick={() => onOpen(document)}
      >
        {opening ? OPENING_LABEL : document.locked ? LOCKED_LABEL : OPEN_LABEL}
      </button>
    </li>
  );
}
